import { TranslationBody, TranslationBodyLanguageEnum } from '@data/sdk/match';
import { Language } from '@data/utils/enums';

export const translationsToRequestValues = (translations: { [key in Language]: string }) =>
  Object.values(Language).reduce((acc, language) => {
    acc.push({
      language: language as TranslationBodyLanguageEnum,
      value: translations[language] || translations[Language.EN],
      autoGenerate: !translations[language],
    });

    return acc;
  }, [] as TranslationBody[]);
